module.exports = __webpack_public_path__ + "img/product_121.a7efba1.webp";